import { logEvent, setUserId } from "firebase/analytics";
import { analytics } from "config/firebase";

interface PageViewEvent {
  page_title?: string;
  page_location?: string;
  page_path?: string;
  user_id?: string;
}

export const setAnalyticsUserId = (userId: string | null) => {
  try {
    if (userId) {
      setUserId(analytics, userId);
      console.log("Analytics: User ID set", userId);
    } else {
      setUserId(analytics, null);
      console.log("Analytics: User ID cleared");
    }
  } catch (error) {
    console.error("Analytics: Failed to set user ID", error);
  }
};

export const trackPageView = (pagePath: string, pageTitle?: string, userId?: string) => {
  try {
    const eventData: PageViewEvent = {
      page_path: pagePath,
      page_location: window.location.href,
    };

    if (pageTitle) {
      eventData.page_title = pageTitle;
    }

    // Only include user_id if it's a valid string
    if (userId && typeof userId === 'string' && userId.trim() !== '') {
      eventData.user_id = userId;
    }

    logEvent(analytics, "page_view", eventData);

    // Only log userId in console if it's defined to reduce noise
    const logData: any = {
      path: pagePath,
      title: pageTitle,
      location: window.location.href,
    };
    
    if (userId && typeof userId === 'string' && userId.trim() !== '') {
      logData.userId = userId;
    }

    console.log("Analytics: Page view tracked", logData);
  } catch (error) {
    console.error("Analytics: Failed to track page view", error);
  }
};

export const trackCustomEvent = (
  eventName: string,
  parameters?: Record<string, any>,
  userId?: string,
) => {
  try {
    const eventData = { ...parameters };
    if (userId) {
      eventData.user_id = userId;
    }
    
    logEvent(analytics, eventName, eventData);
    console.log(`Analytics: Custom event tracked - ${eventName}`, eventData);
  } catch (error) {
    console.error("Analytics: Failed to track custom event", error);
  }
};
